import { api, API } from "./_client";

export async function listTemplates() {
    const { data } = await api.get(`/templates`);
    return data;
}

export async function createTemplate(payload) {
    const { data } = await api.post(`/templates`, payload);
    return data;
}

export async function updateTemplate(id, payload) {
    const { data } = await api.patch(`/templates/${id}`, payload);
    return data;
}

export async function deleteTemplate(id) {
    const { data } = await api.delete(`/templates/${id}`);
    return data;
}

export async function reorderTemplates(templateIds) {
    const { data } = await api.post(`/templates/reorder`, {
        template_ids: templateIds,
    });
    return data;
}

export async function getTemplateTree(id) {
    const { data } = await api.get(`/templates/${id}/tree`);
    return data;
}

export async function createTemplateCategory(templateId, payload) {
    const { data } = await api.post(`/templates/${templateId}/categories`, payload);
    return data;
}

export async function updateTemplateCategory(id, payload) {
    const { data } = await api.patch(`/template-categories/${id}`, payload);
    return data;
}

export async function deleteTemplateCategory(id) {
    const { data } = await api.delete(`/template-categories/${id}`);
    return data;
}

export async function createTemplateItem(categoryId, payload) {
    const { data } = await api.post(`/template-categories/${categoryId}/items`, payload);
    return data;
}

export async function updateTemplateItem(id, payload) {
    const { data } = await api.patch(`/template-items/${id}`, payload);
    return data;
}

export async function deleteTemplateItem(id) {
    const { data } = await api.delete(`/template-items/${id}`);
    return data;
}

// --- AI Estimator ---
// createEstimate is defined near analyzeProject above (both use pollAiJob).

export function templateCsvExportUrl(templateId) {
    // For direct <a href> download — attaches Authorization via a short-lived fetch.
    return `${API}/templates/${templateId}/export-csv`;
}

export async function importTemplateCsv(templateId, file, mode = "append") {
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await api.post(
        `/templates/${templateId}/import-csv?mode=${mode}`,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } },
    );
    return data;
}

// Unified template importer — auto-detects Planswift .SwiftTemplates or
// image/screenshot (Bluebeam snip, Excel screenshot, PDF page, photo) and
// hands it to the backend for parsing / AI vision.

export async function importTemplateAny(fd) {
    const { data } = await api.post(`/templates/import`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
        // AI-vision path can take ~10-30s on a large screenshot — bump
        // timeout to 3 minutes to leave headroom on slower pages.
        timeout: 180000,
    });
    return data;
}

// Reset a project — wipes every AI takeoff shape attached to any of its
// documents. Preserves uploads, page splits, analyses, and estimates.

export async function importSwiftTemplate(fd) {
    return importTemplateAny(fd);
}

// --- Pinned PDF export ---

export async function getTemplatesInjectionPrompt() {
    const { data } = await api.get("/admin/templates-injection-prompt");
    return data;
}

export async function updateTemplatesInjectionPrompt(prompt) {
    const { data } = await api.patch("/admin/templates-injection-prompt", { prompt });
    return data;
}
